import React from 'react';
import Modal from 'components/Modal.jsx';
import JoinInfoPage from './JoinInfoPage.jsx';

const JoinInfoModal = React.createClass({
  propTypes: {
    onDone: React.PropTypes.func.isRequired,
    code: React.PropTypes.string.isRequired,
  },

  onDone() {
    this.props.onRequestHide();
    this.props.onDone();
  },

  render() {
    return (
      <Modal size="small" {...this.props}>
        <JoinInfoPage code={this.props.code} onDone={this.onDone} />
      </Modal>
    );
  },
});

export default JoinInfoModal;



// WEBPACK FOOTER //
// ./src/join/components/JoinInfoModal.jsx